// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "1.19.11/static/js/" + chunkId + "." + {"130":"5837e4ad","450":"c18d9b82"}[chunkId] + ".chunk.js";
};